<template>
  <v-container fluid class="">
    <!-- <v-row justify="center" class="live-body">
      <v-col cols="12" md="8">
        <video width="100%" autoplay loop controls>
          <source src="../../public/videos/steam_video_1.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </v-col>
    </v-row> -->
    <v-row justify="center" align="center" class="live-body">
     <v-col cols="12" md="10" class="d-flex justify-center">
      <iframe 
        src="https://drive.google.com/file/d/1md0sDIcF1hiHft2PcYGdiDMUT7XTfuY2/preview" 
        frameborder="0" 
        allowfullscreen
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share; fullscreen"
        class="video-frame"
      ></iframe>
     </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Home",

  data() {
    return {
      carouselHeight: "500px", // Default value
    };
  },

  mounted() {
    this.updateCarouselHeight(); // Set initial height
    window.addEventListener("resize", this.updateCarouselHeight);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.updateCarouselHeight);
  },

  methods: {
    getDynamicHeight() {
      return window.innerWidth < 600 ? "300px" : "500px"; // Adjust height for mobile
    },
    updateCarouselHeight() {
      this.carouselHeight = this.getDynamicHeight();
    },
  },
};
</script>

<style scoped>

.carousel-image {
  width: 100%;
  height: 100%;
  max-height: 100vh; /* Prevents excessive height */
  object-fit: contain; /* Ensures full image visibility */
}

.live-body {
  background-color: rgba(0, 0, 0, 0.5);
  margin-bottom: 5px;
}

.video-frame {
  width: 100%;
  max-width: 900px; /* Adjust as needed */
  height: 500px; /* Adjust as needed */
  display: block;
}
</style>
